import {
  Box,
  Card,
  CardContent,
  Grid,
  Skeleton,
  Stack,
  Avatar,
} from "@mui/material";

function LeadHeaderSkeleton() {
  return (
    <Card
      sx={{
        borderRadius: 5,
        bgcolor: "rgba(255,255,255,0.86)",
        backdropFilter: "blur(12px)",
        boxShadow: "0 8px 28px rgba(0,0,0,0.08)",
        width: "100%",
        overflow: "hidden",
      }}
    >
      <CardContent>
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={4}
          alignItems={{ xs: "center", md: "flex-start" }}
          sx={{ width: "100%" }}
        >
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            sx={{ width: "100%", maxWidth: 400 }}
          >
            <Avatar sx={{ width: 90, height: 90, bgcolor: "#e5e7eb" }} />

            <Box sx={{ flexGrow: 1 }}>
              <Skeleton height={32} width="80%" sx={{ mb: 1 }} />

              <Skeleton
                height={36}
                width={140}
                sx={{
                  borderRadius: 1,
                }}
              />
            </Box>
          </Stack>

          <Grid container spacing={2} sx={{ width: "100%", maxWidth: 720 }}>
            {[1, 2, 3, 4].map((i) => (
              <Grid key={i} size={{ xs: 12, sm: 6 }}>
                <Box
                  sx={{
                    p: 2.2,
                    borderRadius: 4,
                    bgcolor: "#fafafa",
                    display: "flex",
                    gap: 2,
                    alignItems: "center",
                    height: 76,
                    width: "100%",
                  }}
                >
                  <Skeleton
                    variant="rounded"
                    width={42}
                    height={42}
                    sx={{ borderRadius: "14px" }}
                  />

                  <Box sx={{ flexGrow: 1 }}>
                    <Skeleton height={16} width="40%" />
                    <Skeleton height={20} width="80%" sx={{ mt: 1 }} />
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Stack>
      </CardContent>
    </Card>
  );
}

export default function LeadDetailsSkeleton() {
  return (
    <Box sx={{ p: { xs: 2, md: 4 }, background: "#f5f6fa" }} minHeight="90vh">
      <LeadHeaderSkeleton />

      <Box sx={{ mt: 4 }}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 3 }}>
            <Card
              sx={{
                borderRadius: 1,
                bgcolor: "rgba(255,255,255,0.9)",
                backdropFilter: "blur(10px)",
                p: 2,
                height: "100%",
              }}
            >
              <Skeleton height={28} width="60%" />
              <Stack spacing={2} sx={{ mt: 2 }}>
                {[1, 2, 3].map((i) => (
                  <Box
                    key={i}
                    sx={{
                      p: 2,
                      borderRadius: 4,
                      bgcolor: "#fafafa",
                      display: "flex",
                      gap: 2,
                      alignItems: "center",
                      height: 72,
                    }}
                  >
                    <Skeleton variant="circular" width={40} height={40} />
                    <Box sx={{ width: "70%" }}>
                      <Skeleton height={16} width="50%" />
                      <Skeleton height={20} width="80%" sx={{ mt: 1 }} />
                    </Box>
                  </Box>
                ))}
                <Skeleton height={10} width="80%" />
              </Stack>
            </Card>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <Card
              sx={{ borderRadius: 1, bgcolor: "#ffffff", p: 2, height: "100%" }}
            >
              <Skeleton height={28} width="40%" />
              <Stack spacing={2} sx={{ mt: 2 }}>
                {[1, 2, 3].map((i) => (
                  <Box
                    key={i}
                    sx={{
                      display: "flex",
                      gap: 2,
                      alignItems: "center",
                      p: 1.5,
                      height: 70,
                    }}
                  >
                    <Skeleton
                      variant="rounded"
                      width={40}
                      height={40}
                      sx={{ borderRadius: 2 }}
                    />
                    <Box sx={{ flexGrow: 1 }}>
                      <Skeleton height={16} width="60%" />
                      <Skeleton height={14} width="40%" sx={{ mt: 1 }} />
                    </Box>
                    <Skeleton height={16} width={40} />
                  </Box>
                ))}
              </Stack>
            </Card>
          </Grid>

          <Grid size={{ xs: 12, md: 3 }}>
            <Card
              sx={{
                borderRadius: 1,
                bgcolor: "rgba(255,255,255,0.9)",
                backdropFilter: "blur(10px)",
                p: 2,
                height: "100%",
              }}
            >
              <Skeleton height={28} width="60%" />
              <Stack spacing={5} sx={{ mt: 3 }}>
                {[1, 2, 3].map((i) => (
                  <Stack
                    direction="row"
                    spacing={3}
                    key={i}
                    sx={{ height: 80 }}
                  >
                    <Skeleton variant="circular" width={60} height={60} />
                    <Box>
                      <Skeleton height={20} width={80} />
                      <Skeleton height={16} width={120} sx={{ mt: 1 }} />
                    </Box>
                  </Stack>
                ))}
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
